import React from "react";
import { useSelector } from "react-redux";
import Hand from "../../../../assets/images/hand.png";

export const WelcomeBanner = () => {
  const formattedDate = new Date().toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
  const {
    userInfo
  } = useSelector((state) => state.auth);

  return (
    <div className="w-full col-start-1 col-end-9">
      <div className="flex justify-between p-5 border border-offSlate w-full rounded-lg">
        <div className="flex flex-col items-start">
          <span className="text-f16 text-dHeading2">{formattedDate}</span>
          <h1 className="text-f24 font-semibold text-dHeading">
            Welcome {userInfo?.name ?? ""}
          </h1>
        </div>
        <img src={Hand} alt={userInfo?.name ?? ""} />
      </div>
    </div>
  );
};
